import React, { useContext, useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import * as ActionTypes from '../../../constants/action-types';
import { EntitiesContext } from '../../../App';
import { useGetAccountInventory } from '../../../hooks/useAccount';
import Loader from '../../Loader';

export default function PrintVendors() {
  const entities = useContext(EntitiesContext);
  const vendors = entities.state.get('account').filter(a => a.role === 'vendor');
  const inventory = entities.state.get('inventory');

  const vendorInventory = useGetAccountInventory();

  useEffect(() => {
    Promise.all(vendors.map(v => vendorInventory.mutateAsync(v)));

    // having the vendor inventory identifiers on state can mess things up elsewhere
    // clear them out on unmount
    return function cleanup() {
      entities.dispatch({
        type: ActionTypes.CLEAR_ENTITIES,
        payload: 'inventory'
      })
    }
  }, []);

  const data = () => {
    const vendorsWithInventory = vendors.filter(v => inventory.find(i => i.account_id === v.id));
    const rows = [...Array( Math.ceil(vendorsWithInventory.count() / 2) )];
    const productRows = rows.map((row, idx) => vendorsWithInventory.slice(idx * 2, idx * 2 + 2));

    const content = productRows.map((row, idx) => (
      <div className="columns" key={idx}>
        {row.valueSeq().map(v => <div key={v.id} className="column">
          <div className="columns">
            <div className="column is-narrow">
              <QRCode size={75} value={inventory.find(i => i.account_id === v.id && i.isVendorIdentifer).id.toString()} />
            </div>
            <div className="column">
              id: {v.id}<br/>
              Vendor Name: {v.vendor_name}<br/>
            </div>
          </div>
        </div>)}
      </div>)
    );

    return <div>{content}</div>;
  }

  if (inventory.count() <= 0 || vendors.count() <= 0) return <Loader />;

  return (<div className="has-text-left">{data()}</div>)
}
